import Skeleton from "../../../components/Skeleton/Skeleton";
import TableSkeleton from "../../../components/Skeleton/ui/TableSkeleton/TableSkeleton";
import MobileTableSkeleton from "./MobileTableSkeleton/MobileTableSkeleton";
import useScreenSize from "../../../hooks/useScreenSize";

const PageSkeleton = () => {
  const { isMobile } = useScreenSize();

  if (isMobile) return <MobileTableSkeleton />;

  return (
    <div className="flex flex-col gap-4 h-full min-h-[100vh]">
      <div className="flex gap-6">
        {Array.from({ length: 8 }).map((_, i) => (
          <Skeleton key={i} width="80px" height="32px" />
        ))}
      </div>
      <TableSkeleton numberOfColumns={5} numberOfRows={10} />
    </div>
  );
};

export default PageSkeleton;
